import { AxiosResponse } from "axios";
import { api } from ".";
import { ILoginResponse, IUserResponse } from "../api/auth";

export interface IloginPayload {
  username: string;
  password: string;
}

export const loginUser = async (payload: IloginPayload): Promise<ILoginResponse> => {
  const formData = new FormData();
  formData.append("username", payload.username);
  formData.append("password", payload.password);
  formData.append("scope", "read");
  formData.append("grant_type", "password");

  return api.post("o/token/", formData);
};

export const getUserDetails = async (): Promise<AxiosResponse<IUserResponse>> => {
  return api.get("v2/auth/me/");
};

export function logoutUser(payload?: Record<string, unknown>) {
  return api.post("v2/auth/logout/", payload);
}
